// extracted by mini-css-extract-plugin
export default {"root":"xZqwIZ8","preloaderItem":"LdJWRVI"};